import React from "react";
import { Youtube, Linkedin, Facebook, Instagram, Mail, Phone } from "lucide-react";
import FooterLogo from "@/components/FooterLogo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-950 text-slate-300 pt-16 pb-8 mt-6"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 pb-10 border-b border-slate-800">
          {/* Brand */}
          <div className="md:col-span-2">
            <a href="#home" data-testid="footer-logo-link" className="inline-block bg-transparent">
              <FooterLogo />
            </a>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
              The smarter way to source commodities. Run live reverse auctions
              with verified manufacturers and secure the best global prices.
            </p>

            <div id="contact" className="mt-8 space-y-4 text-sm text-slate-400">
              <div className="flex items-center gap-3">
                <Mail size={16} className="flex-shrink-0 text-slate-500" aria-hidden />
                <a
                  href="mailto:info@demaxtore.com"
                  data-testid="footer-email"
                  className="hover:text-white transition-colors"
                >
                  info@demaxtore.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="flex-shrink-0 text-slate-500" aria-hidden />
                <a
                  href="tel:+905411135009"
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  +90 541 113 50 09
                </a>
              </div>
            </div>

          </div>

          {/* Links */}
          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-4">
              Platform
            </h4>
            <ul className="space-y-2.5 text-sm">
              {["How it works", "Categories", "Pricing", "Security"].map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-2.5 text-sm">
              {[
                ["About", "#"],
                ["Contact", "#contact"],
                ["Careers", "#"],
                ["Press", "#"],
              ].map(([l, href]) => (
                <li key={l}>
                  <a
                    href={href}
                    data-testid={l === "Contact" ? "footer-nav-contact" : undefined}
                    className="hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} CommodityBid. Designed by DeMaxtore.
          </p>
          <div className="flex items-center gap-3">
            {[
              { Icon: Youtube, label: "YouTube" },
              { Icon: Linkedin, label: "LinkedIn" },
              { Icon: Facebook, label: "Facebook" },
              { Icon: Instagram, label: "Instagram" },
            ].map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                data-testid={`social-${label.toLowerCase()}`}
                aria-label={label}
                onClick={(e) => e.preventDefault()}
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
